import React from 'react';
import AppBar from './components/AppBar/index.jsx'
import './style/style.styl'
import ErrorPage from './pages/Errorpage.jsx';
import ChatStats from './pages/chatstats/ChatStats';
import injectSheet from 'react-jss';
import Text from './components/Text';

import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch,
    Link
} from 'react-router-dom'

import { IS_PRODUCTION } from "../constants";
import { init } from '@streamelements/alchemy';

init();

const App = (props) => {
    const { classes } = props;

    return (
        <div style={{
            maxWidth: '100vw',
            overflowX: 'hidden'
        }}>
            <AppBar/>

            <div className={classes.wrapper}>
                <Text type="h2" classList={[classes.title]}>StreamElements Chat Stats</Text>
                <Text type="text" classList={[classes.subhead]}>Recording dank memes from Twitch Chat since, January 9th 2016</Text>
            </div>

            <Router>
                <Switch>
                    <Route exact path="/" component={ChatStats}/>
                    <Route path="/c/:channel" component={ChatStats}/>
                    <Route component={ErrorPage}/>
                </Switch>
            </Router>
        </div>
    )
};

const styles = theme => ({
    wrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        marginTop: theme.spacing * 11,
        marginBottom: theme.spacing * 3
    },
    title: {
        fontWeight: 300,
        textTransform: 'none'
    },
    subhead: {
        fontWeight: 300,
        textTransform: 'none',
        textAlign: 'center',
    }
})

export default injectSheet(styles)(App);



// WEBPACK FOOTER //
// ./src/app/App.js